import { Injectable, Inject } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class DashboardService {
  private API_URL: string;
  private token: any;
  private idToken: any;

  constructor(private http: HttpClient, @Inject('API_URL') apiUrl: string) {
    this.API_URL = apiUrl;
    this.token = localStorage.getItem('token');
    this.idToken = localStorage.getItem('id_token');
  }

  getEmbeddedUrl(dashboardId: string, contentId: string): Observable<{ embed_url: string }> {
    const headers = new HttpHeaders().set('Authorization', `${this.token}`).set('id_token', `${this.idToken}`);
    const url = `${this.API_URL}/dashboard/embedURL?dashboardId=${dashboardId}&contentId=${contentId}`;
    return this.http.get<{ embed_url: string }>(url, { headers })
  }
}
